import classNames from "classnames";
import * as React from "react";

type Props = {
    frontComponent: React.ReactNode;
    backComponent: React.ReactNode;
    showBack: boolean;
};

/**
 * A composite view that display a front view and a back view, animating the
 * transition with a card flip animation.
 *
 * Adapted from http://davidwalsh.name/css-flip
 */
export default class FlippableCardView extends React.Component<Props> {
    render(): React.ReactNode {
        const flippableCardClasses = classNames({
            "flippable-card": true,
            "show-back": this.props.showBack,
        });

        return (
            <div className="flippable-card-container">
                <div className={flippableCardClasses}>
                    <div className="card-front">
                        {this.props.frontComponent}
                    </div>
                    <div className="card-back">{this.props.backComponent}</div>
                </div>
            </div>
        );
    }
}
